<template>
  <v-app style="margin: 0px; padding: 0px; width: 100%; height: 100%">
    <v-main>
      <v-container
        fluid
        fill-height
        :class="$vuetify.breakpoint.xs ? 'pa-0 ma-0' : ''"
      >
        <v-card
          :loading="this.isLoading"
          :class="$vuetify.breakpoint.xs ? 'ma-0 pa-5' : 'mt-4 px-5 pb-5'"
          outlined
          elevation="2"
          :width="$vuetify.breakpoint.xs ? '100%' : '450px'"
          :style="
            $vuetify.breakpoint.xs
              ? 'padding: 0; margin: 0;'
              : 'padding: auto; margin: auto;'
          "
        >
          <template slot="progress">
            <v-progress-linear
              color="accent"
              indeterminate
              height="5px"
            ></v-progress-linear>
          </template>
          <v-btn
            id="back-button"
            style="transform: translateX(-200px); position: absolute"
            type="submit"
            color="primary"
            plain
            :href="loginRoute"
          >
            <v-icon dark left> mdi-arrow-left </v-icon>Back To Login
          </v-btn>
          <v-form
            class="text-center"
            method="POST"
            :action="forgottenPasswordRoute"
          >
            <input type="hidden" name="_token" :value="csrf" />
            <v-card-title class="justify-center pt-5 pb-8"
              >Reset password</v-card-title
            >
            <v-card-subtitle class="text-left"
              >Enter the email address associated with your account, and we'll
              send you a link to reset your password
            </v-card-subtitle>
            <v-text-field
              id="email"
              v-model="email"
              type="email"
              name="email"
              label="Email"
              :rules="emailRules"
              outlined
              hide-details="auto"
              validate-on-blur
            ></v-text-field>

            <v-btn
              :disabled="this.isLoading"
              color="primary"
              id="register"
              type="submit"
              medium
              depressed
              >Send reset email</v-btn
            >
          </v-form>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      email: "",
      emailRules: [
        (v) => !!v || "You must enter an email address",
        (v) => /.+@.+\.[^\s]/.test(v) || "E-mail must be valid",
      ],
      isLoading: false,
    };
  },
  props: {
    errors: String,
    "login-route": String,
    "forgotten-password-route": String,
    csrf: String,
  },
};
</script>
<style scoped>
/*Vuetify*/

.v-card {
  padding: 0 20px 20px 20px;
}

.v-input {
  margin-bottom: 10px !important;
  margin-left: 15px !important;
  margin-right: 15px !important;
}
</style>
